import { render } from "./Footer.vue?vue&type=template&id=0a905756&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=0a905756&scoped=true&lang=css"

import exportComponent from "/home/work/buildspace/y645Wy1Hed/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a905756"]])

export default __exports__